<template>
  <TMainForm :script-id="scriptId" :interception="interception" :buttons="buttons" :default-design="defaultDesign"
    ref="MainForm" :default-change-script="defaultChangeScript" :default-proccess-script="defaultProccessScript" />
</template>

<script setup>
/**
 * TTMFacilityCustomForm
 */
import TMainForm from './TMainForm.vue';
import { REPEATED_FORM_DESIGNS } from './constants';
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

const store = useStore();
const route = useRoute();

const props = defineProps({
  scriptId: { type: Number, default: null },
  interception: { type: [String, Object, Boolean], default: null },
});
const MainForm = ref(null);

const buttons = computed(() => [
  {
    key: 'FACILITY_RUN',
    loadedValue: 'COMMAND_ON',
    index: 15,
    name: 'Запуск',
    click: () => {
      store.dispatch("addScriptLog", {
        message: `Кнопка не задана FACILITY_RUN`,
        facilityId: route.params.facility_id,
      });
      // MainForm.value?.writeLoadedValue('FACILITY_RUN', 'COMMAND_ON', 0);
    },
  },
  {
    key: 'FACILITY_STOP',
    loadedValue: 'COMMAND_OFF',
    index: 16,
    name: 'Стоп',
    click: () => {
      store.dispatch("addScriptLog", {
        message: `Кнопка не задана FACILITY_STOP`,
        facilityId: route.params.facility_id,
      });
      // MainForm.value?.writeLoadedValue('FACILITY_STOP', 'COMMAND_OFF', 0);
    },
  },
  {
    key: 'RESET_ALARM',
    index: 11,
    name: 'Сброс аварии',
    click: () => {
      store.dispatch("addScriptLog", {
        message: `Кнопка не задана RESET_ALARM`,
        facilityId: route.params.facility_id,
      });
      // MainForm.value?.write('RESET_ALARM', 1, 0);
    },
  },
]);

const defaultDesign = REPEATED_FORM_DESIGNS.design;
const defaultChangeScript = REPEATED_FORM_DESIGNS.changeScript;
const defaultProccessScript = REPEATED_FORM_DESIGNS.processScript;
</script>
